/* unplugin-vue-components disabled */import { render } from "./specialTopicDetail.vue?vue&type=template&id=9b2b0c1e&scoped=true&ts=true"
import script from "./specialTopicDetail.vue?vue&type=script&lang=ts"
export * from "./specialTopicDetail.vue?vue&type=script&lang=ts"

import "./specialTopicDetail.vue?vue&type=style&index=0&id=9b2b0c1e&scoped=true&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9b2b0c1e"]])

export default __exports__